<template>
  <div class="contentBox">
    <navBox :id="navId" :cid="childrenID" ref="navBox"></navBox>
    <!-- 列表 -->
    <div class="content" >
      <myHeader ref="myHeader"></myHeader>
      <div class="detail">
        <p class="title">练习报告</p>
        <div class="cont">
          <p class="msg">学生姓名: {{detailData.name}}</p>
          <p class="msg1">距离结营时间还剩: {{detailData.diff_day}}天</p>
          <div class="progress">
            <p class="result-title">总练习进度</p>
            <div class="line">
              <div class="bg" :style="{ width: detailData.rate + '%'}"></div>
              <p>{{detailData.rate}}%</p>
            </div>
          </div>
          <div class="progress">
            <p class="result-title">总时间长度</p>
            <div class="line">
              <div class="bg" :style="{ width: detailData.time_progress + '%'}"></div>
              <p>{{detailData.time_progress}}%</p>
            </div>
          </div>
        </div>
        <div class="result-item cont">
          <p class="result-title">母题讲解练习</p>
          <div class="result-list">
            <div class="list-item" v-for="(item,index) in detailData.videos" :key="index">
              <p class="list-title">第{{numberToChinese(item.week)}}周</p>
              <div class="list-cont">
                <div class="list-txt">
                  <p class="num">{{item.complete}}<span>个</span></p>
                  <p class="status">已完成</p>
                </div>
                <div class="list-txt list-txt2">
                  <p class="num">{{item.incomplete}}<span>个</span></p>
                  <p class="status">未完成</p>
                </div>
                <div class="list-txt">
                  <p class="num">{{item.rate}}<span>%</span></p>
                  <p class="status">母题讲解练习进度</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="result-item cont">
          <p class="result-title">习题刻意练习</p>
          <div class="result-list">
            <div class="list-item" v-for="(item,index) in detailData.topics" :key="index">
              <p class="list-title">第{{numberToChinese(item.week)}}周</p>
              <div class="list-cont">
                <div class="list-txt">
                  <p class="num">{{item.complete}}<span>个</span></p>
                  <p class="status">已完成</p>
                </div>
                <div class="list-txt list-txt2">
                  <p class="num">{{item.incomplete}}<span>个</span></p>
                  <p class="status">未完成</p>
                </div>
                <div class="list-txt">
                  <p class="num">{{item.rate}}<span>%</span></p>
                  <p class="status">习题刻意练习进度</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="result-item cont">
          <p class="result-title">每周正确率</p>
          <div ref="chart" class="chartBox"></div>
          <span class="total">总正确率: {{detailData.acc}}%</span>
        </div>
        <div class="result-item cont">
          <p class="result-title">每周错题复盘</p>
          <div class="result-list">
            <div class="list-item" v-for="(item,index) in detailData.replay" :key="index">
              <p class="list-title">第{{numberToChinese(item.week)}}周</p>
              <div class="list-cont list-cont1" v-if="item.week_topic_error_num == 0">
                <img src="./../assets/images/icon18.png" alt="">
                <p>无错题</p>
              </div>
              <div class="list-cont" v-else>
                <div class="list-txt">
                  <p class="num">{{item.complete}}<span>个</span></p>
                  <p class="status">已完成</p>
                </div>
                <div class="list-txt list-txt2">
                  <p class="num">{{item.incomplete}}<span>个</span></p>
                  <p class="status">未完成</p>
                </div>
                <div class="list-txt">
                  <p class="num">{{item.rate}}<span>%</span></p>
                  <p class="status">错题复盘率</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getReadStudentReport } from "@/assets/js/api";
import * as echarts from 'echarts';
import navBox from './../components/comment/nav.vue';
import myHeader from './../components/comment/myHeader.vue';
export default {
  name: "login",
  data() {
    return {
      navId:'8',
      childrenID:'8-1',
      token:'',
      detailData:'',
      obj:{
        user_id:'',
        rmid:'',
      }
    };
  },
  mounted(){
    var userData = JSON.parse(localStorage.getItem('userData'));
    this.token = userData.adminToken;
    this.obj = {
      user_id:this.$route.query.user_id,
      rmid:this.$route.query.rmid,
    }
    this.getDeatil();
  },
  components: {
    navBox,
    myHeader
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.chartResize);
  },
  methods: {
    async getDeatil(){
      var that = this;
      try {
        const response = await getReadStudentReport(this.obj,this.token);
        if(response.code == 200){
          that.detailData = response.data;
          var list1 = [];
          var list2 = [];
          response.data.accuracys.forEach(function(item,index){
            console.log(item)
            list1.push('第'+item.week+'周正确率')
            list2.push(item.acc)
          });
          that.initChart(list1,list2);
          window.addEventListener('resize', this.chartResize);
        } else {
          that.$message(response.msg);
        }
      } catch (error) {
        that.$message(error);
      }
    },

    initChart(list1,list2) {
      // 基于准备好的dom，初始化echarts实例
      const myChart = echarts.init(this.$refs.chart);
      // 指定图表的配置项和数据
      const option = {
        tooltip: {
          show: true,
        },
        legend: {
          data:['正确率']
        },
        xAxis: {
            type: 'category',
            data: list1
        },
        yAxis: {
            type: 'value'
        },
        series: [{
          data: list2,
          type: 'line',
          label: {
              show: true // 显示数值
          }
        }]
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },

    chartResize() {
      this.$nextTick(() => {
        if (this.chart) {
          this.chart.resize();
        }
      });
    },

    numberToChinese(num) {
      const chineseNums = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'];
      const chineseUnits = ['', '十', '百', '千', '万', '亿', '兆'];
    
      if (num === 0) {
        return chineseNums[0];
      }
    
      const digits = Math.floor(num).toString().split('');
      const len = digits.length;
      
      let result = '';
      
      for (let i = 0; i < len; i++) {
        const digit = parseInt(digits[i]);
        const unit = chineseUnits[len - 1 - i];
        
        if (digit !== 0) {
          result += chineseNums[digit] + unit;
        } else {
          if (result[result.length - 1] !== chineseNums[0]) {
            result += chineseNums[digit]
          }
        }
      }
      
      return result;
    }
},

  
};
</script>
<style scoped>
  .title{
    color: #333333;
    font-size: 24px;
    display: block;
    font-weight: bold;
  }

  .msg{
    font-size: 20px;
    color: #333333;
    display: block;
    margin: 10px 0 20px;
  }

  .msg1{
    font-size: 18px;
    color: #000000;
    display: block;
    margin-bottom: 20px;
  }

  .progress{
    margin-bottom: 20px;
  }

  .progress .line{
    width: 626px;
    height: 30px;
    background-color: #B2CDF9;
    border-radius: 49px;
    position: relative;
    margin: 10px 0 0 ;
  }

  .progress .line .bg{
    width: 10%;
    background-color: #6098F2;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 49px;
  }

  .progress .line p{
    font-size: 24px;
    color: #000000;
    position: absolute;
    top: 50%;
    right: -70px;
    transform: translate(0,-50%);
  }

  .result-title{
    font-size: 20px;
    color: #333333;
    text-align: left;
  }

  .title::before,
  .result-title::before{
    content: '';
    width: 8px;
    height: 26px;
    background-color: #6098F2;
    display: inline-block;
    vertical-align: top;
    margin-right: 15px;
  }

  .result-list{
    margin-top: 20px;
  }

  .list-item{
    margin-bottom: 10px;
  }

  .list-title{
    display: block;
    font-size: 18px;
    color: #333333;
    text-align: left;
    margin: 20px 20px 10px;
  }

  .list-cont{
    margin-left: 60px;
  }

  .list-cont1 img{
    width: 100px;
    height: 94px;
    display: inline-block;
    vertical-align: top;
  }

  .list-cont1 p{
    font-size: 26px;
    color: #333333;
    display: inline-block;
    vertical-align: top;
    line-height: 94px;
    margin-left: 30px;
  }

  .list-txt{
    width: 120px;
    height: 120px;
    border-radius: 6px;
    display: inline-block;
    vertical-align: top;
    box-sizing: border-box;
    padding: 33px 19px;
    background-image: url(~@/assets/images/bg3.png);
    background-size: 120px 120px;
    text-align: center;
  }

  .list-txt .num{
    color: #333333;
    font-size: 26px;
    font-weight: bold;
  }

  .list-txt .num span{
    font-size: 14px;
  }

  .list-txt .status{
    color: #2476F9;
    font-size: 10px;
    margin-top: 10px;
  }

  .list-txt2{
    margin: 0 30px;
    background-image: url(~@/assets/images/bg4.png);
  }

  .list-txt2 p.num,
  .list-txt2 p.status{
    color: #777777;
  }
  
  .detail{
    margin: 0 auto;
    display: block;
    height: calc( 100% - 100px );
    overflow-y: auto;
    overflow-x: hidden;
  }

  .chartBox{
    width: 100%;
    height: 500px;
    display: block;
    margin-top: 30px;
  }

  .total{
    font-size: 20px;
    color: #333333;
    margin-top: 30px;
    display: block;
    text-align: left;
  }

  .cont{
    background-color: #fff;
    border-radius: 6px;
    display: block;
    margin: 20px;
    box-sizing: border-box;
    padding: 30px;
  }

  .content{
    background-color: #F8F9FC;
  }
</style>



// WEBPACK FOOTER //
// src/marketing/result.vue